import { render, staticRenderFns } from "./VoucherPercentage.vue?vue&type=template&id=47907db6"
import script from "./VoucherPercentage.vue?vue&type=script&lang=js"
export * from "./VoucherPercentage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports